import { useCallback, useEffect, useMemo, useRef } from 'react'
import { BlipChat } from 'blip-chat-widget'
import { useSelector } from 'react-redux'
import get from 'lodash.get'

import SystemServices from 'services/SystemService'

const BlipChatWrapper = () => {
  const user = useSelector((state) => get(state, 'userContact', null))
  const notificationRef = useRef(null)
  const originalFaviconRef = useRef(null)
  const blinkIntervalRef = useRef(null)

  const createAudio = useCallback(() => {
    if (!notificationRef.current) {
      notificationRef.current = new Audio('/assets/audio/notification-1.mp3')
    }
  }, [])

  if (!originalFaviconRef.current) {
    const link = document.querySelector("link[rel~='icon']")
    if (link) {
      originalFaviconRef.current = link.href
    }
  }

  const setFavicon = useCallback((url) => {
    let link = document.querySelector("link[rel~='icon']")

    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }

    link.href = url
  }, [])

  const stopBlinking = useCallback(() => {
    if (blinkIntervalRef.current) {
      clearInterval(blinkIntervalRef.current)
      blinkIntervalRef.current = null

      if (originalFaviconRef.current) {
        setFavicon(originalFaviconRef.current)
      }
    }
  }, [setFavicon])

  const startBlinking = useCallback(() => {
    let showAlert = false

    stopBlinking()

    blinkIntervalRef.current = setInterval(() => {
      showAlert = !showAlert

      setFavicon(
        showAlert ? '/assets/favicons/red-circle.png' : '/assets/favicons/white-circle.png',
      )
    }, 500)
  }, [stopBlinking, setFavicon])

  const startBlip = useCallback(
    (metadata) => {
      const widget = new BlipChat()
        .withAppKey(process.env.BLIP_KEY)
        .withButton({ color: '#7906a9' })
        .withCustomCommonUrl('https://azship.chat.blip.ai/')
        .withAccount(metadata || {})
        .withEventHandler(BlipChat.ENTER_EVENT, () => {
          notificationRef.current = null
          stopBlinking()
        })
        .withEventHandler(BlipChat.LEAVE_EVENT, () => {
          createAudio()
        })

      widget.build()
    },
    [stopBlinking, createAudio],
  )

  const checkReceivedMessageBlip = useCallback(
    (e) => {
      if (e?.data?.code && e.data?.code === 'NewBotMessage') {
        notificationRef.current?.play().catch((err) => {
          console.warn('Não foi possível tocar o som:', err)
        })

        startBlinking()
      }
    },
    [startBlinking],
  )

  useEffect(() => {
    window.addEventListener('message', checkReceivedMessageBlip)

    const handleFocus = () => stopBlinking()
    window.addEventListener('focus', handleFocus)

    return () => {
      window.removeEventListener('message', checkReceivedMessageBlip)
      window.removeEventListener('focus', handleFocus)
      stopBlinking()
    }
  }, [checkReceivedMessageBlip, stopBlinking])

  useEffect(() => {
    if (user) {
      SystemServices.chatUserData({
        type: 'TRANSPORTER',
        phone: user.phone || '',
        username: user.username || '',
      }).then((res) => {
        if (res.ok) {
          const {
            transporterUserMail,
            transporterUserName,
            transporterUserPhone,
            transporterDocument,
            transporterName,
            type,
          } = res.data

          startBlip({
            fullName: transporterUserName,
            email: transporterUserMail,
            phoneNumber: transporterUserPhone,
            extras: {
              Tipo: type,
              'Nome da transportadora': transporterName,
              CNPJ: transporterDocument,
              Operações: get(res.data, 'transporterOperations', [])
                .map((item) => item.name)
                .join(', '),
            },
          })

          return
        }
        startBlip()
      })
    }
  }, [startBlip, user])

  return null
}

export default BlipChatWrapper
